import UpdateOms from "../components/omslist/UpdateOmsList";

const UpdateOmsPage = () =>{
    return(
     <UpdateOms/>
    )
}
export default UpdateOmsPage;